import { Box, Button, Modal, Text } from '@fozito/common-ui';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { FooterActions } from '../../components/styles';
type Props = {
  onOk: () => void;
  onCancel: () => void;
};
type Ref = {
  open: () => void;
};
export const useModalCashierAutoSaveRef = () => useRef<Ref>(null);
const ModalCashierAutoSave = forwardRef<Ref, Props>(({ onOk, onCancel }, ref) => {
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const onOpen: Ref['open'] = () => setOpen(true);
  useImperativeHandle(ref, () => ({
    open: onOpen
  }));

  const handleDone = () => {
    onClose();
    onOk();
  };
  const handleCancel = () => {
    onClose();
    onCancel();
  };

  return (
    <Modal title='Changes Detected' open={open} onClose={onClose} width={700} onOk={handleDone}>
      <Box padding={24} textAlign='center'>
      <Text title_h6_20_regular>You have modified some fields in the form. If you leave without saving, your changes will be lost. Do you want to save them now?</Text>
      </Box>
      <FooterActions>
        <Button style={{ flex: 1 }} onClick={handleCancel} type_cancel><span>Discard</span></Button>
        <Button style={{ flex: 1 }} onClick={handleDone} type_primary><span>Save</span></Button>
      </FooterActions>
    </Modal>
  );
});
ModalCashierAutoSave.displayName = 'ModalCashierAutoSave';
export default ModalCashierAutoSave;